import { environment } from "../../config";
import {
  iDataSuborganizacion,
  PostSuborgFields,
  PutSuborgFields,
} from "../../interfaces/SuperAdmin/Pages/iDataSuborganizacion";
import {
  iDataUserSuborg,
  UserSuborgFields,
} from "../../interfaces/SuperAdmin/Pages/iDataUserSuborg";
import { fetchData } from "./httpClient";

const { REACT_APP_API_CONTROL_TRANSACCIONAL } = environment;
const baseApiBroker = REACT_APP_API_CONTROL_TRANSACCIONAL;

/* 
------------------------------------------------- 
SUBORGANIZACION
-------------------------------------------------
*/

export const getSuborganizationsByOrgId = (id: string) =>
  fetchData<iDataSuborganizacion[]>({
    method: "GET",
    url: `${baseApiBroker}/suborganizacion`,
    params: { id_organizacion: id },
  });

export const getSuborganizationById = (id: string) =>
  fetchData<iDataSuborganizacion>({
    method: "GET",
    url: `${baseApiBroker}/suborganizacion/${id}`,
  });

export const postSuborganization = (data: PostSuborgFields) =>
  fetchData<iDataSuborganizacion>({
    method: "POST",
    url: `${baseApiBroker}/suborganizacion`,
    data,
  });

export const deleteSuborganizationById = (id: string) =>
  fetchData<{}>({
    method: "DELETE",
    url: `${baseApiBroker}/suborganizacion/${id}`,
  });

export const putSuborganizationById = (data: PutSuborgFields, id: string) =>
  fetchData<iDataSuborganizacion>({
    method: "PUT",
    url: `${baseApiBroker}/suborganizacion/${id}`,
    data,
  });

/* 
------------------------------------------------- 
USUARIO-SUBORGANIZACION
-------------------------------------------------
*/

export const getUsersInSuborg = (
  id_suborganizacion?: string,
  id_usuario?: string
) =>
  fetchData<iDataUserSuborg[]>({
    method: "GET",
    url: `${baseApiBroker}/usuario-suborganizacion`,
    params: {
      ...(id_suborganizacion && { id_suborganizacion }),
      ...(id_usuario && { id_usuario }),
    },
  });

export const postUsersInSuborg = (data: UserSuborgFields) =>
  fetchData<iDataUserSuborg[]>({
    method: "POST",
    url: `${baseApiBroker}/usuario-suborganizacion`,
    data,
  });

export const deleteUsersInSuborg = (data: UserSuborgFields) =>
  fetchData<[]>({
    method: "DELETE",
    url: `${baseApiBroker}/usuario-suborganizacion`,
    data,
  });
